import { CheckboxElement } from 'react-hook-form-mui';
import { FormattedMessage } from 'react-intl';

export function YoutubeMadeForKidsField() {
  return (
    <CheckboxElement
      name="madeForKids"
      label={
        <FormattedMessage
          id="socialExport.youtube.madeForKids"
          defaultMessage="Contenido apto para niños"
        />
      }
    />
  );
}
